import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { LogoImage, Link } from './headerLogo.styles';
import { PlatformDetector } from '../../../components/platformDetector/platformDetector.component';

import desktopLogo from '../../../images/logo-desktop.svg';
import mobileLogo from '../../../images/logo-mobile.svg';
import { getSrc } from '../../../utils/cmsData';

export class HeaderLogo extends PureComponent {
  static propTypes = {
    logo: PropTypes.object,
    logoMobile: PropTypes.object,
  };

  getLogo = (isMobile) => {
    const { logo, logoMobile } = this.props;

    if (isMobile) {
      return logoMobile ? getSrc(logoMobile) : mobileLogo;
    }

    return logo ? getSrc(logo) : desktopLogo;
  };

  render() {
    return (
      <PlatformDetector>
        {({ isMobile }) => (
          <Link url="/">
            <LogoImage src={this.getLogo(isMobile)} alt="logo" />
          </Link>
        )}
      </PlatformDetector>
    );
  }
}
